var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.roundClass]},[_c('img',{class:[_vm.imgClass, _vm.full ? 'w-full h-full' : ''],style:({ minHeight: _vm.height, minWidth: _vm.width }),attrs:{"src":_vm.url,"alt":""},on:{"load":_vm.handleLoad,"error":_vm.handleError}})])
}
var staticRenderFns = []

export { render, staticRenderFns }